// extracted by mini-css-extract-plugin
module.exports = {"image":"ArtInfoModal_image__L5Jke","infoWrapper":"ArtInfoModal_infoWrapper__3IoSB","infoItem":"ArtInfoModal_infoItem__GTKti","data":"ArtInfoModal_data__2D78K"};